export default "__VITE_ASSET__C3cqALS4__"